"use client";

// The one host for the intake's sheets on the dashboard (MOVING-IN-PLAN.md §7, §15).
//   ?moved=<run>             "what moved in" / "what netti folded" (the link an ai hands back, a river row)
//   ?fold=<project>:<commit> one of netti's project folds
//   OPEN_MOVED_EVENT · OPEN_FOLD_EVENT (lib/intake/open): the inbox, the river and netti open them in place
// Two sheets never stack: opening one closes the other. Closing takes the word out
// of the address, so a reload never opens it again.

import { useEffect, useState } from "react";
import { MovedInSheet } from "./MovedIn";
import { FoldSheet } from "./FoldSheet";
import { OPEN_FOLD_EVENT, OPEN_MOVED_EVENT } from "../../lib/intake/open";

const UUID = /^[0-9a-f-]{36}$/i;
// a project by its id (the fold route checks it is a uuid of the person's own)
const PID = /^[0-9a-z_-]{1,64}$/i;

export default function MovedInArrival() {
  const [runId, setRunId] = useState<string | null>(null);
  const [fold, setFold] = useState<{ project: string; commit: string } | null>(null);
  useEffect(() => {
    try {
      const sp = new URLSearchParams(window.location.search);
      // the address is read once, after mount (the server never sees it)
      const id = sp.get("moved");
      // eslint-disable-next-line react-hooks/set-state-in-effect
      if (id && UUID.test(id)) setRunId(id);
      const f = sp.get("fold");
      const [project, commit] = (f ?? "").split(":");
      if (project && commit && PID.test(project)) setFold({ project, commit });
    } catch {
      /* the address is only one way in here */
    }
    const onMoved = (e: Event) => {
      const run = (e as CustomEvent<{ run?: string }>).detail?.run;
      if (run && UUID.test(run)) {
        setFold(null);
        setRunId(run);
      }
    };
    const onFold = (e: Event) => {
      const d = (e as CustomEvent<{ project?: string; commit?: string }>).detail;
      if (d?.project && d.commit && PID.test(d.project)) {
        setRunId(null);
        setFold({ project: d.project, commit: d.commit });
      }
    };
    window.addEventListener(OPEN_MOVED_EVENT, onMoved);
    window.addEventListener(OPEN_FOLD_EVENT, onFold);
    return () => {
      window.removeEventListener(OPEN_MOVED_EVENT, onMoved);
      window.removeEventListener(OPEN_FOLD_EVENT, onFold);
    };
  }, []);
  const clean = (key: string) => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete(key);
      window.history.replaceState(window.history.state, "", url.pathname + (url.search ? url.search : "") + url.hash);
    } catch {
      /* the sheet is shut either way */
    }
  };
  return (
    <>
      <MovedInSheet runId={runId} onClose={() => { setRunId(null); clean("moved"); }} />
      <FoldSheet fold={fold} onClose={() => { setFold(null); clean("fold"); }} />
    </>
  );
}
